import { BandeiraCartao } from "src/app/shared/bandeira-cartao";

export const environment = {
  production: true,
  urlBaseAPI: "https://apis.brasilcap.info/checkout/",
  codConvenio: 2774925473
};

export const Bandeiras: BandeiraCartao[] = [
  { src: '../assets/images/credit-card/logo_ccvisa.svg', alt: 'Visa', id: "001" },
  { src: '../assets/images/credit-card/logo_ccmastercard.svg', alt: 'Master', id: "002" },
  { src: '../assets/images/credit-card/logo_ccelo.svg', alt: 'Elo', id: "007" }
];
